import { apiCall } from "./api";

export interface ChatMessageRequest {
  message_text: string;
  timestamp: number;
  sender: {
    id: string;
    name: string;
    email: string | null;
  };
  connection_id?: string;
}

export interface ChatMessageResponse {
  id: number;
  meeting_id: number;
  message_text: string;
  timestamp: number;
  sender: {
    id: string;
    name: string;
    email: string | null;
  };
  created_at: string;
}

export interface ChatMessagesResponse {
  success: boolean;
  data: {
    messages: ChatMessageResponse[];
    pagination: {
      total: number;
      count: number;
      has_more: boolean;
      next_timestamp: number | null;
    };
  };
}

/**
 * Save a chat message to the backend
 * @param meetingId - The meeting ID
 * @param message - The message data to save
 * @returns The saved message response
 */
export const saveChatMessage = async (
  meetingId: string,
  message: ChatMessageRequest
): Promise<ChatMessageResponse> => {
  const response = await apiCall().post(
    `/meetings/${meetingId}/messages`,
    message
  );
  return response.data;
};

/**
 * Retrieve chat messages for a meeting
 * @param meetingId - The meeting ID
 * @param options - Optional query parameters (since, limit, order)
 * @returns The messages and pagination data
 */
export const getChatMessages = async (
  meetingId: string,
  options?: {
    since?: number;
    limit?: number;
    order?: "asc" | "desc";
  }
): Promise<ChatMessagesResponse> => {
  const response = await apiCall().get(`/meetings/${meetingId}/messages`, {
    params: options,
  });
  return response.data;
};
